module.exports = __webpack_public_path__ + "img/coin250.6e4aee8a.png";